/**
 * Created by Jie Gao on 2019-02-12.
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {PickAndClickController} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {SymbolIdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/symbolidleanimation/SymbolIdleAnimationController";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {StarStruckBetline} from "./betline/StarStruckBetline";
import {StarStruckBetlineNumber} from "./betline/StarStruckBetlineNumber";
import {StarStruckBetlinesView} from "./betline/StarStruckBetlinesView";
import {BonusWinEffect} from "./effects/BonusWinEffect";
import {ForegroundView} from "./foreground/ForegroundView";
import {LandscapePaytable} from "./foreground/paytable/LandscapePaytable";
import {PortraitPaytable} from "./foreground/paytable/PortraitPaytable";
import {HotZone} from "./hotzone/HotZone";
import {Logo} from "./logo/Logo";
import {NearWinBackground} from "./nearwin/NearWinBackground";
import {StarStruckPickNClick} from "./picknclick/StarStruckPickNClick";
import {StarStruckPickNClickScreen} from "./picknclick/StarStruckPickNClickScreen";
import {StarStruckReelAreaView} from "./reel/StarStruckReelAreaView";
import {StarStruckReelController} from "./reel/StarStruckReelController";
import {StarStruckReelPartAnimator} from "./reel/StarStruckReelPartAnimator";
import {StarStruckReels} from "./reel/StarStruckReels";
import {BonusSymbolLanding} from "./reelstoppresentation/bonussymbollanding/BonusSymbolLanding";
import {StopHotZoneController} from "./reelstoppresentation/StopHotZoneController";
import {StarStruckParsedGameData} from "./server/data/StarStruckParsedGameData";
import {StarStruckParsedInitData} from "./server/data/StarStruckParsedInitData";
import {StarStruckServerDataParser} from "./server/StarStruckServerDataParser";
import {SoundPlayer} from "./soundplayer/SoundPlayer";
import {StarStruckSpinController} from "./spin/StarStruckSpinController";
import {StarStruckFontConfig} from "./StarStruckFontConfig";
import {StarStruckGameAssets} from "./StarStruckGameAssets";
import {StarStruckGameConfig} from "./StarStruckGameConfig";
import {StarStruckSoundConfig} from "./StarStruckSoundConfig";
import {StarStruckReelSymbol} from "./symbols/StarStruckReelSymbol";
import {StarStruckReelSymbolStateCreator} from "./symbols/StarStruckReelSymbolStateCreator";
import {StarStruckBigWinController} from "./winpresentation/bigwin/StarStruckBigWinController";
import {StarStruckBetLineWinIndividualWPController} from "./winpresentation/individualwin/StarStruckBetLineWinIndividualWPController";
import {StarStruckInitialWPController} from "./winpresentation/initial/StarStruckInitialWPController";
import {IndiSymWinHighlightPresentation} from "./winpresentation/IndiSymWinHighlightPresentation";

export class StarStruckGameModuleConfig implements IGameModuleConfig {

    public static instance:StarStruckGameModuleConfig = new StarStruckGameModuleConfig();

    GAME_CONFIG:IGameConfig = StarStruckGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = StarStruckSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = StarStruckFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = StarStruckGameAssets.RESOURCES_GROUPS;

    public static nearwinBackground:NearWinBackground;
    public static hotZone:HotZone;
    public static soundPlayer:SoundPlayer;
    public static bonusWinEffect:BonusWinEffect;

    constructor() {
        if(StarStruckGameModuleConfig.instance) {
            throw new Error("StarStruckGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    SERVER_PARSER:() => ServerDataParser = () => new StarStruckServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new StarStruckParsedInitData(data, <StarStruckServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new StarStruckParsedGameData(data, <StarStruckServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new StarStruckSpinController();

    REEL_AREA_VIEW:() => ReelAreaView = () => new StarStruckReelAreaView();
    REELS:() => Reels = () => new StarStruckReels();
    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new StarStruckReelController(reelId);
    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    REEL_PART_ANIMATOR:(reelId:number) => SpinReelPartAnimator = reelId => reelId === 1 ? new StarStruckReelPartAnimator(reelId) : new SpinReelPartAnimator(reelId);
    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):StarStruckReelSymbol => new StarStruckReelSymbol(symName, reelId, state)
    );
    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new StarStruckReelSymbolStateCreator();

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new BonusSymbolLanding(index),
        (index:number) => new StopHotZoneController(index)
    ];

    PICK_AND_CLICKS:(() => PickAndClickController)[] = [
        () => new StarStruckPickNClick("StarStruckPickNClick", {
            viewCreator : (onButtonClickCallback:(index:number, auto:boolean) => void, autoClick?:boolean) => {
                return new StarStruckPickNClickScreen({
                    layer : StarStruckGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    recreateButtons : true
                }, autoClick);
            },
            showWinPresentations : true
        })
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new IndiSymWinHighlightPresentation(indexes)],
        [
            indexes => new StarStruckBigWinController(indexes),
            indexes => new StarStruckInitialWPController(indexes)
        ]
    ];
    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new StarStruckBetLineWinIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        if(!UserAgent.isMobile) {
            const idleAnimation = new SymbolIdleAnimationController({
                startTime : 3,
                minInterval : 0.1,
                maxInterval : 3
            });
        }

        const paytableConfig:any = {
            values : ["M1", "M2", "M3", "M4", "M5", "L1", "MX"],
            symbols : ["Group_M", "M2", "M3", "M4", "M5", "Group_L", "Group_Bar"],
            background : {
                color : "#ffffff",
                alpha : 0.5
            },
            textStyle : {
                fontFamily : "Open Sans",
                fontSize : 24,
                fontWeight : "bold",
                fill : ['#ffffcc', '#ff9900'], // gradient
                dropShadow : true,
                dropShadowColor : '#000000',
                dropShadowBlur : 2,
                dropShadowAngle : Math.PI / 2,
                dropShadowDistance : 3
            }
        };
        const gamePanel = new ForegroundView();
        const portraitPaytable = new PortraitPaytable(paytableConfig);
        const landscapePaytable = new LandscapePaytable(paytableConfig);
        StarStruckGameModuleConfig.nearwinBackground = new NearWinBackground();
        StarStruckGameModuleConfig.hotZone = new HotZone();
        StarStruckGameModuleConfig.bonusWinEffect = new BonusWinEffect();
        const logo = new Logo();

        StarStruckGameModuleConfig.soundPlayer = new SoundPlayer();

        const background = new StillImageBackground({
            layer : GameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : StarStruckGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                STAR_PICK_SELECTION : {
                    image : StarStruckGameAssets.MAIN_GAME_BACKGROUND,
                    offset : new PIXI.Point(-480, -480)
                }
            },
            stretch : false
        });

        const betLinesView = new StarStruckBetlinesView(
            {
                map : [
                    4, 1, 2, 3, 5, 5, 1, 2, 3, 4
                ]
            },
            (index:number):StarStruckBetlineNumber => {
                return new StarStruckBetlineNumber(index, {
                    layer : GameConfig.instance.LAYERS.BET_LINE_NUMBERS.name,
                    width : 40,
                    height : 40,
                    horizontalPadding : GameConfig.instance.REEL_AREA_POS_X + 44,
                    verticalPadding : [
                        GameConfig.instance.REEL_AREA_POS_Y + 40,
                        (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT)) + 40
                    ],
                    textStyleNormal : {
                        fontFamily : "Open Sans",
                        fontSize : 30,
                        fontWeight : "bold",
                        fill : "#a6759a"
                    },
                    textStyleWin : {
                        fontFamily : "Open Sans",
                        fontSize : 30,
                        fontWeight : "bold",
                        fill : "#ffffff",
                        stroke : "#dfb8cd",
                        strokeThickness : 2,
                        padding : 4

                    },
                    textWinScale : 1
                });
            },
            (index:number, numberPosition:number[], betLineData:number[]):StarStruckBetline => {
                return new StarStruckBetline(index, numberPosition, betLineData, {
                    staticLineLayer : GameConfig.instance.LAYERS.BET_LINES.name,
                    styles : [
                        {
                            "lineWidth" : 3,
                            "color" : 0xffffff,
                            "alpha" : 1
                        },
                        {
                            "lineWidth" : 1,
                            "color" : 0xdfb8cd,
                            "alpha" : 1
                        }
                    ],
                    numberOffsetX : 20,
                    pointOverlapVerticalOffset : 8
                });
            }
        );

        StageManager.legacyScaling = true;
    };
}